/* unplugin-vue-components disabled */import { render } from "./DashBoardDoughnutChart.vue?vue&type=template&id=1f4b7140&scoped=true&ts=true"
import script from "./DashBoardDoughnutChart.vue?vue&type=script&lang=ts"
export * from "./DashBoardDoughnutChart.vue?vue&type=script&lang=ts"

import "./DashBoardDoughnutChart.vue?vue&type=style&index=0&id=1f4b7140&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4b7140"]])

export default __exports__